import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        card: {
            display: 'flex',
            alignItems: 'center',
            gap: ['xsmall.base', 'xsmall.sm', 'xsmall.md', 'xsmall.lg'],
            width: '100%',
        },
        icon: {
            boxSize: remCalc(24),
            flexShrink: 0,
            color: 'foreground.neutral.default',
        },
        textContainer: {
            flex: 1,
            gap: 0,
            alignItems: 'flex-start',
        },
        textContent: {
            width: '100%',
            gap: ['micro.base', 'micro.sm', 'micro.md', 'micro.lg'],
            alignItems: 'flex-start',
        },
        titleText: {
            textStyle: 'body-small',
            fontWeight: 'medium',
            color: 'foreground.neutral.default',
        },
        subtitleText: {
            textStyle: 'body-small',
            fontWeight: 'normal',
            color: 'foreground.neutral.muted',
        },
        titleRow: {
            gap: remCalc(8),
        },
        urlLink: {
            display: 'block',
            width: '100%',
            color: 'inherit',
            textDecoration: 'underline',
            _hover: {
                textDecoration: 'underline',
            },
            _focus: {
                boxShadow: 'none',
            },
        },
        infoPopBox: {
            display: 'flex',
            alignSelf: 'center',
            height: remCalc(16),
        },
        infoIcon: {
            boxSize: remCalc(16),
            cursor: 'pointer',
            color: 'foreground.neutral.default',
        },
        flexWithTooltip: {
            gap: ['small.base', 'small.sm', 'small.md', 'small.lg'],
            align: 'center',
        },
    },
    parts: [
        'card',
        'icon',
        'textContainer',
        'urlLink',
        'textContent',
        'titleText',
        'subtitleText',
        'infoPopBox',
        'infoIcon',
        'flexWithTooltip',
    ],
}
